<template>
  <div class="video-play-container">
    <video controls :src="'./video/' + videoname"></video>
    <div
      :class="isMolile ? 'mobile-back-icon-box' : 'back-icon-box'"
      @click="backPage"
    >
      <img :src="backIcon" class="back-icon" />
    </div>
  </div>
</template>

<script>
import backIcon from "../assets/icon/back.png";
export default {
  name: "ContentVideoPlay",

  data() {
    return {
      videoname: null,
      backIcon,
      isMolile: null,
    };
  },
  methods: {
    backPage() {
      sessionStorage.removeItem("videoName");
      this.$router.go(-1);
    },
  },
  created() {
    this.videoname = sessionStorage.getItem("videoName");
    this.isMolile = +sessionStorage.getItem("isMobile");
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.video-play-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  video {
    width: 100%;
    height: 100%;
    object-fit: contain;
    margin: 0;
    padding: 0;
  }
  .mobile-back-icon-box {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 25px;
    top: 20px;
    width: 40px;
    height: 40px;
    background: rgba(0, 0, 0, 0.25);
    border: none;
    border-radius: 50%;
    z-index: 2;
    cursor: pointer;
    img {
      user-select: none;
      -webkit-user-select: none; /*禁用手机浏览器的用户选择功能 */
      -moz-user-select: none;
      width: 25px;
      height: 25px;
    }
  }
  .back-icon-box {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 50px;
    top: 40px;
    width: 80px;
    height: 80px;
    background: rgba(0, 0, 0, 0.25);
    border: none;
    border-radius: 50%;
    z-index: 2;
    cursor: pointer;
    img {
      width: 50px;
      height: 50px;
    }
  }
}
</style>
